// START IMPORTS
import { CustomIcons, useTheme } from '@ltvco/refresh-lib/theme';
import { NavLinkDataV2 } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import {
  Security,
  Message,
  List,
  Policy,
  Radar,
  HelpRounded,
  LightbulbRounded,
  WarningRounded,
} from '@mui/icons-material';
// END IMPORTS

// START INTERFACES_AND_TYPES
type DataCounts = {
  commentsLength: number;
};
// END INTERFACES_AND_TYPES

// START HELPER_FUNCTIONS
export const getFraudPhoneNavLinkDataV2 = (DataCounts: DataCounts) => {
  const theme = useTheme();

  let threatDetection: NavLinkDataV2[] = [];

  threatDetection = [
    {
      href: '#threat-detection-section',
      sectionId: '#threat-detection-section',
      labelText: 'Threat Detection',
      hideReportItemsCount: true,
      icons: [<Radar sx={{ color: theme.palette.primary.main }} />],
    },
  ];

  return [
    {
      href: '#fraud-phone-overview-section',
      sectionId: '#fraud-phone-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          key="phone-fraud-overview-icon"
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'phone-fraud-phone-overview-section',
    },
    ...threatDetection,

    {
      href: '#comments-section',
      sectionId: '#comments-section',
      labelText: 'Comments',
      icons: [<Message sx={{ color: theme.palette.primary.main }} />],
      reportItemsCount: DataCounts.commentsLength,
    },
  ];
};

export const getFraudEmailNavLinkDataV2 = () => {
  const theme = useTheme();
  const isEmailFraudRedesign = useFeatureIsOn('RFRSH-4333');

  const darkWebNavItems: NavLinkDataV2[] = isEmailFraudRedesign
    ? [
        {
          href: '#additional-details-section',
          sectionId: '#additional-details-section',
          labelText: 'Additional Details',
          icons: [<List sx={{ color: theme.palette.primary.main }} />],
          hideReportItemsCount: true,
        },
        {
          href: '#dark-web-breaches-section',
          sectionId: '#dark-web-breaches-section',
          labelText: 'Data Breaches',
          icons: [
            <WarningRounded
              key="dark-web-breaches-section"
              sx={{ color: theme.palette.primary.main }}
            />,
          ],
          hideReportItemsCount: true,
        },
        {
          href: '#dark-web-breach-tips-section',
          sectionId: '#dark-web-breach-tips-section',
          labelText: 'Breach Tips',
          icons: [
            <LightbulbRounded
              key="dark-web-breach-tips-section"
              sx={{ color: theme.palette.primary.main }}
            />,
          ],
          hideReportItemsCount: true,
        },
        {
          href: '#dark-web-coverage-section',
          sectionId: '#dark-web-coverage-section',
          labelText: 'Scan Coverage',
          icons: [
            <CustomIcons.ScanCoverageIcon
              key="dark-web-coverage-section"
              sx={{
                color: theme.palette.primary.main,
                fontSize: '1.5rem',
              }}
            />,
          ],
          hideReportItemsCount: true,
        },
        {
          href: '#dark-web-faq-section',
          sectionId: '#dark-web-faq-section',
          labelText: 'FAQs',
          icons: [
            <HelpRounded
              key="dark-web-faq-section"
              sx={{ color: theme.palette.primary.main }}
            />,
          ],
          hideReportItemsCount: true,
        },
      ]
    : [];

  return [
    {
      href: '#fraud-email-overview-section',
      sectionId: '#fraud-email-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          key="email-fraud-overview-icon"
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'email-fraud-overview-section',
    },
    ...darkWebNavItems,
    ...(!isEmailFraudRedesign
      ? [
          {
            href: '#additional-details-section',
            sectionId: '#additional-details-section',
            labelText: 'Additional Details',
            icons: [<List sx={{ color: theme.palette.primary.main }} />],
            hideReportItemsCount: true,
          },
        ]
      : []),
  ];
};

export const getFraudIpNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-ip-overview-section',
      sectionId: '#fraud-ip-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'ip-fraud-overview-section',
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};

export const getFraudUrlNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-url-overview-section',
      sectionId: '#fraud-url-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'url-fraud-overview-section',
    },
    {
      href: '#risk-details-section',
      sectionId: '#risk-details-section',
      labelText: 'Risk Details',
      icons: [<Policy sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};
// END HELPER_FUNCTIONS
